import { render, staticRenderFns } from "./IconZoomOutSolid.vue?vue&type=template&id=0736a2c5"
import script from "./IconZoomOutSolid.vue?vue&type=script&lang=js"
export * from "./IconZoomOutSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports